<script lang="ts">
export default {
    name: "HistoryVideoPop",
};
</script>

<script setup lang="ts">
import { onMounted } from "vue"
import { store } from '@/store'
import { addFlightLogEvent, getWayLineInfo } from "@/api/eventApi/index"

const props = defineProps({
    isEvent: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
});

// 事件表单
const formData = reactive<any>({});
const wayLineObj: any = ref()
const dockData: any = inject("imageBase");

const emits = defineEmits(["update:isEvent"]);
const deviceInfo1 = computed(() => JSON.parse(JSON.stringify(store.other.useMyStore().deviceState.deviceInfo)))

const handleSubmit = () => {
    if (deviceInfo1.value) {
        formData.lng = deviceInfo1.value[store.informationListStore.informationStore().uavObj.childSn].longitude
        formData.lat = deviceInfo1.value[store.informationListStore.informationStore().uavObj.childSn].latitude
    }
    formData.orgId = wayLineObj.value.org_id
    formData.gatewaySn = wayLineObj.value.device_sn
    formData.aircraftSn = store.informationListStore.informationStore().uavObj.childSn
    formData.jobId = ""
    formData.eventTime = new Date().getTime()
    formData.base64Image = dockData
    addFlightLogEvent(formData).then((res: any) => {
        ElMessage.success("上传成功")
        close()
    })
}

const close = () => {
    emits("update:isEvent", false);
}

watch(() => props.isEvent, (newVal: any, oldVal) => {
    if (newVal) {
        // console.log(deviceInfo1.value[store.informationListStore.informationStore().uavObj.childSn])
        // console.log(store.informationListStore.informationStore().uavObj.childSn)
        if (sessionStorage.getItem("wayline_id")) {
            getWayLineInfo(sessionStorage.getItem("wayline_id")).then((res) => {
                wayLineObj.value = res
            })
        }
    }
}, {
    deep: true
})

</script>

<template>
    <div class="eventPop-box" v-if="isEvent">
        <p class="close" @click="close">
            <img src="@/assets/icons/video-close.png" alt="">
        </p>
        <div class="event-pic">
            <img :src="dockData" alt="">
        </div>
        <el-form ref="folderFormRef" :model="formData" label-width="100px" :inline="true" class="formBox">
            <el-form-item label="事件地点：" prop="name">
                <el-input v-model="formData.name" placeholder="请输入事件地点" />
            </el-form-item>
            <el-form-item label="事件类型：" prop="eventType">
                <el-input v-model="formData.eventType" placeholder="请输入事件类型" />
            </el-form-item>
            <el-form-item label="事件描述：" prop="description">
                <el-input v-model="formData.description" placeholder="请输入事件描述" />
            </el-form-item>
        </el-form>
        <div class="button" @click="handleSubmit">上传事件</div>
    </div>
</template>

<style lang="scss" scoped>
.eventPop-box {
    position: absolute;
    width: 988px;
    height: 670px;
    border-radius: 8px;
    opacity: 1;
    z-index: 999;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: url("@/assets/icons/event-pop-bg.png") no-repeat;
    background-size: 100% 100%;
    pointer-events: all;

    .close {
        width: 24px;
        height: 24px;
        position: absolute;
        right: -10px;
        top: -6px;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .event-pic {
        width: 920px;
        margin: 0 auto;
        margin-top: 69px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .formBox {
        margin-top: 20px;

        :deep(.el-input__wrapper) {
            width: 180px;
            background: rgba(111, 112, 112, 0.4);
            margin-left: 8px;

            .el-range-separator {
                color: #0BE8F6;
            }
        }

        :deep(.el-input__inner) {
            color: #FFFFFF;
        }

        :deep(.el-form-item__label) {
            font-size: 12px;
            font-weight: normal;
            color: #FFFFFF;
        }

        :deep(.el-select__wrapper) {
            width: 220px;
            height: 24px;
            background: rgba(111, 112, 112, 0.4);
        }
    }

    .button {
        width: 75px;
        height: 22px;
        border-radius: 3px;
        background: linear-gradient(270deg, rgba(253, 202, 0, 0.8) 0%, rgba(248, 128, 0, 0.6) 100%);
        border-image: linear-gradient(270deg, #FFFFFF 0%, #FAA700 97%) 0.5;
        backdrop-filter: blur(5.44px);
        cursor: pointer;
        font-family: Alibaba PuHuiTi 2.0;
        font-size: 12px;
        font-weight: 500;
        color: #fff;
        text-align: center;
        line-height: 20px;
        position: absolute;
        right: 27px;
        bottom: 23px;
    }
}
</style>